var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "col-4 d-flex justify-content-end" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-info",
            attrs: { id: "createAnnounceBtn", type: "button" },
            on: { click: _vm.create },
          },
          [_vm._v("新しく登録する")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "main" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-9" }, [
        _c("table", { staticClass: "table table-dark table-sm table-hover" }, [
          _vm._m(1),
          _c(
            "tbody",
            _vm._l(_vm.announces, function (announce, index) {
              return _c("tr", { key: announce.id }, [
                _c("th", { attrs: { scope: "row" } }, [
                  _vm._v(_vm._s(index + 1)),
                ]),
                _c("td", { staticStyle: { "white-space": "pre-wrap" } }, [
                  _vm._v(_vm._s(announce.announce)),
                ]),
                _c("td", [_vm._v(_vm._s(announce.startAt))]),
                _c("td", [_vm._v(_vm._s(announce.endAt))]),
                _c("td", [
                  _c(
                    "button",
                    {
                      staticClass: "btn-sm btn-light",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.modify(announce.id)
                        },
                      },
                    },
                    [_vm._v("編集する")]
                  ),
                ]),
              ])
            }),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "col-3" }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-5" }, [
      _c("h5", [_vm._v("アナウンス一覧")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "70px" }, attrs: { scope: "col" } }, [
          _vm._v("#"),
        ]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("内容")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("通知開始")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("通知終了")]),
        _c("th", { staticStyle: { width: "150px" }, attrs: { scope: "col" } }, [
          _vm._v("操作"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }